export enum Design {
  SmileyFace,
  TabDesignWithSmiley,
  TabDesign,
}
